import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import entityTableService from "../services/entityTableService";
import { Link } from "react-router-dom";

class EntityTable extends Component {
  state = {
    data: [],
    pages: null,
    loading: true,
  };

  fetchData = async (state, instance) => {
    var self = this;
    var delayInMilliseconds = 1500; //1 second
    clearTimeout(this.delayTimer);
    this.delayTimer = setTimeout(async function() {
      await self.doFetchData(self, state);
    }, delayInMilliseconds);
  };

  doFetchData = async (self, state) => {
    self.setState({ loading: true });

    // console.log(state.pageSize, state.page, state.sorted, state.filtered);
    const data = await entityTableService.fetchTableData(state, this.props.url);

    self.setState({
      data: data.rows,
      pages: data.pages,
      loading: false,
    });
  };

  render() {
    const { data, loading, pages } = this.state;
    // Clone columns to avoid mutating props directly and guard against missing ids
    const columns = this.props.columns.slice();
    const linkCol = columns[this.props.linkToEditIndex];
    if (linkCol) {
      linkCol.Cell = (row) => {
        const id = row && row.original ? row.original.id : undefined; // react-table v6
        const content = row && typeof row.value !== "undefined" ? row.value : null;
        return id ? (
          <Link to={`/${this.props.url}/${id}`}>{content}</Link>
        ) : (
          <span>{content}</span>
        );
      };
    }
    return (
      <ReactTable
        manual
        className="my-4"
        data={data}
        pages={pages}
        loading={loading}
        columns={columns}
        filterable
        onFetchData={this.fetchData}
        minRows={this.props.minRows}
      />
    );
  }
}

export default EntityTable;
